class Elementor_Team{
    static instance;

    static getInstance() {
        if (!Elementor_Team.instance) {
            Elementor_Team.instance = new Elementor_Team();
        }
        return Elementor_Team.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-teams.default', ( $scope ) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        } );
    }
}


Elementor_Team.getInstance();